module.exports = __webpack_public_path__ + "img/mob1.d84c06a3.png";